/* Version: 3.5.149 */
'use client';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { version } from 'react';
import hexoid from 'hexoid';

var _excluded = ["style"];
var PX_REM_RATIO = 0.0625;
var safeRest = function safeRest(_ref) {
  _ref.style;
    var props = _objectWithoutProperties(_ref, _excluded);
  return props;
};
var getExternalLink = function getExternalLink(isExternal) {
  return isExternal ? '_blank' : '_self';
};

/**
 * Injects the current version at build time.
 * Replaces string occurrences of `3.5.149` with the version number.
 * NOTE: Only works in production builds, as we use esbuild for local development.
 * @see https://github.com/djhouseknecht/rollup-plugin-version-injector
 */
var getPackageVersion = function getPackageVersion() {
  return '3.5.149';
};
var deprecate = function deprecate(componentName, message) {
  if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test') {
    return;
  }
  // eslint-disable-next-line
  console.warn("[Deprecate] ".concat(componentName, ": ").concat(message)); //NOSONAR
};

/**
 * Determines whether React 18.0+ is used.
 * @returns {boolean}
 */
var isReact18 = function isReact18() {
  var versionStr = version.split('-');
  var versionNum = versionStr && parseFloat(versionStr[0]);
  return !!versionNum && versionNum > 17;
};
var warn = function warn(componentName, message) {
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  // eslint-disable-next-line
  console.warn("".concat(componentName, ": ").concat(message)); //NOSONAR
};

/**
 * Compares two string values to see if they match, irrespective of case
 * @param {string} a
 * @param {string} b
 */
var matches = function matches() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return a.toUpperCase() === b.toUpperCase();
};

/**
 * A no-operation identity function that returns its inputs
 * @param  {...any} rest
 */
var noop = function noop() {
  for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
    rest[_key] = arguments[_key];
  }
  return [].concat(rest);
};

/**
 * Simple unique ID generator that returns a unique ID for a single machine and single process.
 * NOTE: Not server-side rendering (SSR) safe (ie. will cause hydration mismatch).
 * @param {string} [prefix=''] - prefix to append to generated ID
 * @param {number} [length=8] - length of generated ID
 */
var uniqueId = function uniqueId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  return "".concat(prefix).concat(hexoid(length)());
};

/**
 * Replaces spaces in a string with underscores and trims any whitespace
 * @param {string} str - string value to remove spaces from
 */
var sanitizeSpaces = function sanitizeSpaces(str) {
  return str.trim().replace(/ /g, '_');
};

/**
 * Determines if the passed array contains valid error objects or strings
 * @param {array<string>|array<{id: string, isError: bool, msg: string}>} errors - array of error strings or objects { msg(string), id(string), isError(bool) }
 * @returns {bool}
 */
var hasErrors = function hasErrors(errors) {
  return errors.some(function (error) {
    return typeof error === 'string' || error.isError;
  });
};

/**
 * Handles an onBlur event on an input to only call onBlur when focus leaves the entire group
 * Focus moving between items in groupedRefs will NOT call onBlur
 */
var handleGroupedInputsBlur = function handleGroupedInputsBlur(event, onBlur, groupedRefs) {
  var nextFocusedElement = event === null || event === undefined ? undefined : event.relatedTarget;
  var isLeavingGroup = !nextFocusedElement || !groupedRefs.map(function (ref) {
    return ref === null || ref === undefined ? undefined : ref.current;
  }).filter(function (current) {
    return current !== undefined;
  }).includes(nextFocusedElement);
  if (isLeavingGroup) {
    onBlur();
  }
};

/**
 * Convert a px value to a rem value according to the ratio provided by CDS
 * Returns the converted value as a string with 'rem' appended
 * @param {number} px - px value to be converted; it must be a number
 */
var rem = function rem(px) {
  return "".concat(px * PX_REM_RATIO, "rem");
};

export { deprecate, getExternalLink, getPackageVersion, handleGroupedInputsBlur, hasErrors, isReact18, matches, noop, rem, safeRest, sanitizeSpaces, uniqueId, warn };
